import { render, staticRenderFns } from "./BookingAgencyCommissionReportPage.vue?vue&type=template&id=2f89ef85&scoped=true&"
import script from "./BookingAgencyCommissionReportPage.vue?vue&type=script&lang=js&"
export * from "./BookingAgencyCommissionReportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f89ef85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f89ef85')) {
      api.createRecord('2f89ef85', component.options)
    } else {
      api.reload('2f89ef85', component.options)
    }
    module.hot.accept("./BookingAgencyCommissionReportPage.vue?vue&type=template&id=2f89ef85&scoped=true&", function () {
      api.rerender('2f89ef85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/BookingAgencyCommissionReportPage.vue"
export default component.exports